"use client";
// import { ResumeData } from "@/lib/schema";

// // Helper function to handle both old and new language formats
// const getLanguageName = (lang: string | { name: string }): string => {
//   return typeof lang === 'string' ? lang : lang.name;
// };

// export default function Classic({ data }: { data: ResumeData }) {
//   return (
//     <div className="p-6 font-serif text-gray-700">
//       <h1 className="text-3xl font-bold">{data.basics.name}</h1>
//       <p className="italic">{data.basics.title}</p>
//       <p>{data.basics.email} | {data.basics.phone}{data.basics.location ? ` | ${data.basics.location}` : ''}</p>
//       <hr className="my-2" />
//       <p className="mb-4">{data.basics.summary}</p>

//       <h2 className="font-bold text-xl text-black">Experience</h2>
//       {data.experience.map((exp, i) => (
//         <div key={i} className="mb-3">
//           <p className="text-lg text-black">{exp.role} — {exp.company}</p>
//           <p className="text-sm text-black">{exp.startDate} - {exp.current ? 'Present' : exp.endDate}</p>
//           {exp.summary && <p className="mt-1 text-sm">{exp.summary}</p>}
//         </div>
//       ))}

//       <h2 className="font-bold text-xl mt-4 text-black">Education</h2>
//       {data.education.map((edu, i) => (
//         <div key={i} className="mb-2">
//           <p className="text-lg text-black">{edu.degree} — {edu.institution}</p>
//           <p className="text-sm text-black">{edu.startDate} - {edu.endDate}</p>
//         </div>
//       ))}

//       <h2 className="font-bold text-xl mt-4 text-black">Skills</h2>
//       <p>{data.skills.join(", ")}</p>

//       {/* Strengths Section - Only show if data exists */}
//       {data.basics.strengths && data.basics.strengths.length > 0 && (
//         <>
//           <h2 className="font-bold text-xl mt-4 text-black">Strengths</h2>
//           <div className="space-y-2">
//             {data.basics.strengths.map((strength, i) => (
//               <div key={i}>
//                 <p className="font-semibold">{strength.title}</p>
//                 {strength.description && (
//                   <p className="text-sm text-gray-600">{strength.description}</p>
//                 )}
//               </div>
//             ))}
//           </div>
//         </>
//       )}

//       {/* Key Achievements Section - Only show if data exists */}
//       {data.basics.achievements && data.basics.achievements.length > 0 && (
//         <>
//           <h2 className="font-bold text-xl mt-4 text-black">Key Achievements</h2>
//           <div className="space-y-2">
//             {data.basics.achievements.map((achievement, i) => (
//               <div key={i}>
//                 <p className="font-semibold">{achievement.title}</p>
//                 {achievement.description && (
//                   <p className="text-sm text-gray-600">{achievement.description}</p>
//                 )}
//               </div>
//             ))}
//           </div>
//         </>
//       )}
//       {data.basics.languages && data.basics.languages.length > 0 && (
//         <>
//           <h2 className="font-bold text-xl mt-4 text-black">Languages</h2>
//           <p>
//             {Array.isArray(data.basics.languages)
//               ? data.basics.languages
//                   .map((lang) => getLanguageName(lang as string | { name: string }))
//                   .join(", ")
//               : ""}
//           </p>
//         </>
//       )}
//       {data.basics.social && data.basics.social.length > 0 && (
//         <>
//           <h2 className="font-bold text-xl mt-4 text-black">Social Links</h2>
//           <ul>
//             {data.basics.social.map((link, i) => (
//               <li key={i}><span className="font-semibold">{link.label}:</span> <a href={link.url} className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">{link.url}</a></li>
//             ))}
//           </ul>
//         </>
//       )}
//       {data.basics.hobbies && data.basics.hobbies.length > 0 && (
//         <>
//           <h2 className="font-bold text-xl mt-4 text-black">Hobbies & Interests</h2>
//           <p>{data.basics.hobbies.join(", ")}</p>
//         </>
//       )}
//     </div>
//   );
// }

import { ResumeData } from "@/lib/schema";

// Helper function to handle both old and new language formats
const getLanguageName = (lang: string | { name: string }): string => {
  return typeof lang === "string" ? lang : lang.name;
};

export default function Classic({ data }: { data: ResumeData }) {
  return (
    <div
      style={{
        padding: "1rem",
        fontFamily: "serif",
        color: "#374151",
      }}
    >
      <h1
        style={{
          fontSize: "1.875rem",
          fontWeight: "bold" as const,
          margin: "0",
        }}
      >
        {data.basics.name}
      </h1>
      <p
        style={{
          fontStyle: "italic" as const,
          margin: "0.5rem 0",
        }}
      >
        {data.basics.title}
      </p>
      <p
        style={{
          margin: "0.5rem 0",
        }}
      >
        {data.basics.email} | {data.basics.phone}
        {data.basics.location ? ` | ${data.basics.location}` : ""}
      </p>
      <hr
        style={{
          margin: "0.5rem 0",
          border: "0",
          borderTop: "1px solid #e5e7eb",
        }}
      />
      <p
        style={{
          marginBottom: "1rem",
        }}
      >
        {data.basics.summary}
      </p>

      <h2
        style={{
          fontWeight: "bold" as const,
          fontSize: "1.25rem",
          color: "#000000",
          margin: "0",
        }}
      >
        Experience
      </h2>
      {data.experience.map((exp, i) => (
        <div
          key={i}
          style={{
            marginBottom: "0.75rem",
          }}
        >
          <p
            style={{
              fontSize: "1.125rem",
              color: "#000000",
              margin: "0",
            }}
          >
            {exp.role} — {exp.company}
          </p>
          <p
            style={{
              fontSize: "0.875rem",
              color: "#000000",
              margin: "0.25rem 0",
            }}
          >
            {exp.startDate} - {exp.current ? "Present" : exp.endDate}
          </p>
          {exp.summary && (
            <p
              style={{
                marginTop: "0.25rem",
                fontSize: "0.875rem",
              }}
            >
              {exp.summary}
            </p>
          )}
        </div>
      ))}

      <h2
        style={{
          fontWeight: "bold" as const,
          fontSize: "1.25rem",
          color: "#000000",
          marginTop: "1rem",
          margin: "0",
        }}
      >
        Education
      </h2>
      {data.education.map((edu, i) => (
        <div
          key={i}
          style={{
            marginBottom: "0.5rem",
          }}
        >
          <p
            style={{
              fontSize: "1.125rem",
              color: "#000000",
              margin: "0",
            }}
          >
            {edu.degree} — {edu.institution}
          </p>
          <p
            style={{
              fontSize: "0.875rem",
              color: "#000000",
              margin: "0.25rem 0",
            }}
          >
            {edu.startDate} - {edu.endDate}
          </p>
        </div>
      ))}
      <div style={{ marginBottom: "0.5rem", marginTop: "1rem" }}>
        <h2
          style={{
            fontWeight: "bold" as const,
            fontSize: "1.25rem",
            color: "#000000",
          }}
        >
          Skills
        </h2>
        <p>{data.skills.join(", ")}</p>
      </div>
      {/* Strengths Section - Only show if data exists */}
      {data.basics.strengths && data.basics.strengths.length > 0 && (
        <div style={{ marginBottom: "0.5rem", marginTop: "1rem" }}>
          <h2
            style={{
              fontWeight: "bold" as const,
              fontSize: "1.25rem",
              color: "#000000",
            }}
          >
            Strengths
          </h2>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {data.basics.strengths.map((strength, i) => (
              <div key={i}>
                <p
                  style={{
                    fontWeight: "bold" as const,
                  }}
                >
                  {strength.title}
                </p>
                {strength.description && (
                  <p
                    style={{
                      fontSize: "0.875rem",
                      color: "#4b5563",
                    }}
                  >
                    {strength.description}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Key Achievements Section - Only show if data exists */}
      {data.basics.achievements && data.basics.achievements.length > 0 && (
        <div style={{ marginBottom: "0.5rem", marginTop: "1rem" }}>
          <h2
            style={{
              fontWeight: "bold" as const,
              fontSize: "1.25rem",
              color: "#000000",
            }}
          >
            Key Achievements
          </h2>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {data.basics.achievements.map((achievement, i) => (
              <div
                key={i}
                style={{
                  marginBottom: "0.2rem",
                }}
              >
                <p
                  style={{
                    fontWeight: "bold" as const,
                    margin: "0",
                    padding: "0",
                  }}
                >
                  {achievement.title}
                </p>
                {achievement.description && (
                  <p
                    style={{
                      fontSize: "0.875rem",
                      color: "#4b5563",
                      margin: "0",
                      padding: "0",
                    }}
                  >
                    {achievement.description}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
      {data.basics.languages && data.basics.languages.length > 0 && (
        <div style={{ marginBottom: "0.5rem" }}>
          <h2
            style={{
              fontWeight: "bold" as const,
              fontSize: "1.25rem",
              color: "#000000",
              marginTop: "1rem",
              margin: "0",
            }}
          >
            Languages
          </h2>
          <p
            style={{
              margin: "0",
            }}
          >
            {Array.isArray(data.basics.languages)
              ? data.basics.languages
                  .map((lang) =>
                    getLanguageName(lang as string | { name: string })
                  )
                  .join(", ")
              : ""}
          </p>
        </div>
      )}
      {data.basics.social && data.basics.social.length > 0 && (
        <div style={{ marginBottom: "0.5rem" }}>
          <h2
            style={{
              fontWeight: "bold" as const,
              fontSize: "1.25rem",
              color: "#000000",
              marginTop: "1rem",
              margin: "0",
            }}
          >
            Social Links
          </h2>
          <ul
            style={{
              margin: "0",
              padding: "0",
              listStyle: "none",
            }}
          >
            {data.basics.social.map((link, i) => (
              <li
                key={i}
                style={{
                  margin: "0.25rem 0",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold" as const,
                  }}
                >
                  {link.label}:
                </span>{" "}
                <a
                  href={link.url}
                  style={{
                    color: "#2563eb",
                    textDecoration: "underline",
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.url}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
      {data.basics.hobbies && data.basics.hobbies.length > 0 && (
        <div style={{ marginBottom: "0.5rem" }}>
          <h2
            style={{
              fontWeight: "bold" as const,
              fontSize: "1.25rem",
              color: "#000000",
              marginTop: "1rem",
              margin: "0",
            }}
          >
            Hobbies & Interests
          </h2>
          <p
            style={{
              margin: "0",
            }}
          >
            {data.basics.hobbies.join(", ")}
          </p>
        </div>
      )}

      <style jsx>
        {`
          @media print {
            body {
              -webkit-print-color-adjust: exact; /* Ensures exact colors in WebKit browsers */
              print-color-adjust: exact; /* Modern browsers */
              background: #fff !important;
              color: #333 !important;
            }
          }
        `}
      </style>
    </div>
  );
}
